import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { defaultColDef } from "@/setup/ag-grid/mesf-theme";

export const StrandsTable = () => {
  const {
    state: { strandData, casProcessData },
  } = useHeatReportContext();

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div
          style={{ height: "20rem" }}
          key={`${strandData.length}-${casProcessData.ProcessId}`}
        >
          <AgGridReact
            rowData={strandData}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            domLayout="normal"
            getRowId={(params) => params.data.Strand}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
